import ProjectCard from "./ProjectCard";

export default function ProjectPreview() {
const projects = [
    {
      image: "/Images/empkhet.png",
      title: "EmpKhet – Organic E-Commerce Platform",
      description:
        "Full-stack DTC platform built with Next.js, Node.js, and MongoDB. Features server-side rendering and sub-second load times.",
      link: "https://empkhet.com", 
    },
    {
      image: "Images/Smart-Farming-App.png",
      title: "IoT Smart Farming Dashboard",
      description:
        "Real-time IoT monitoring dashboard visualizing sensor data (temperature, humidity) using React, Firebase, and ESP8266.",
      link: "https://smartfarming.co.in/",
    },
    {
      image: "/Images/Quote.png",
      title: "SaaS Quote Template",
      description:
        "B2B HubSpot quote template featuring modular pricing tables and modern SaaS design patterns.",
      link: "https://hubtest-242332888.hubspotpagebuilder.net/aRgry4wk2wxSkGc",
    },
  ];

  return (
    <div>
      <div className="project_card_container">

        {/* Render only the first 3 */}
        {projects.slice(0, 3).map((project, index) => (
          <ProjectCard key={index} {...project} />
        ))}

      </div>

      {/* View All Button */}
      <div className="align_center mt-20">
        <a href="/projects" className="cta_button white border">
          View All Projects →
        </a>
      </div>
      </div>
  );
}
